import type { HTMLAttributes } from "react";

function cn(...parts: Array<string | false | undefined>) {
  return parts.filter(Boolean).join(" ");
}

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  /** Tailwind width class, e.g. w-24 */
  width?: string;
}

/** Pulse placeholder block — base primitive for dashboard loading states. */
export function Skeleton({ className, width, ...props }: SkeletonProps) {
  return (
    <div
      aria-hidden
      className={cn("animate-pulse rounded-md bg-skeleton motion-reduce:animate-none", width, className)}
      {...props}
    />
  );
}

export function SkeletonText({ className, width = "w-full" }: { className?: string; width?: string }) {
  return <Skeleton className={cn("h-3.5", width, className)} />;
}

export function SkeletonBadge({ className }: { className?: string }) {
  return <Skeleton className={cn("h-5 w-16 rounded-full", className)} />;
}

export function SkeletonPills({ count = 3 }: { count?: number }) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton key={index} className="h-5 w-14 rounded-full" />
      ))}
    </div>
  );
}

export function LoadingStatus({ label }: { label: string }) {
  return <span className="sr-only">{label}</span>;
}
